<template>

    <div class="scope-of-works-looper">
        <div v-for="node in items">
            <sow-item :item="node" v-if="node.type === 'scope_of_works_item'"></sow-item>
            <sow-task :task="node" v-if="node.type === 'scope_of_works_task'"></sow-task>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['items'],
    }
</script>

<style lang="scss">
</style>
